<template>
  <div v-if="widgetId && numericProductId" id="productReviews">
    <ClientOnly>
      <div
        class="yotpo-widget-instance"
        :data-yotpo-instance-id="widgetId"
        :data-yotpo-product-id="numericProductId"
        :data-yotpo-name="productName"
        :data-yotpo-url="productUrl"
        :data-yotpo-image-url="productImageUrl"
        :data-yotpo-price="productPrice"
        :data-yotpo-currency="productCurrency"
        :data-yotpo-description="productDescription"
      />
    </ClientOnly>
  </div>
</template>

<script setup>
import { computed, nextTick, onMounted, watch } from 'vue';

const props = defineProps({
  product: {
    type: Object,
    default: null,
  },
});

const { $getCurrentLocaleConfig } = useNuxtApp();

const widgetId = computed(() => $getCurrentLocaleConfig()?.yotpoReviewsWidgetId || null);

const numericProductId = computed(() => {
  const id = props.product?.id;
  if (!id) return null;
  return String(id).split('/').pop() || null;
});

const productName = computed(() => props.product?.title || '');

const firstVariant = computed(() => props.product?.variants?.edges?.[0]?.node || null);

const productPrice = computed(() => firstVariant.value?.price?.amount || '');

const productCurrency = computed(() => firstVariant.value?.price?.currencyCode || '');

const productImageUrl = computed(() => props.product?.images?.edges?.[0]?.node?.src || '');

const productDescription = computed(() => {
  const html = props.product?.descriptionHtml;
  if (!html || !import.meta.client) return '';
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const text = doc.body.textContent || '';
  return text.split(/\s+/).filter(Boolean).join(' ');
});

const productUrl = ref('');
const updateProductUrl = () => {
  if (import.meta.client) {
    productUrl.value = globalThis.location.href;
  }
};

const initYotpoWidgets = async () => {
  await nextTick();
  globalThis.yotpoWidgetsContainer?.initWidgets?.();
};

onMounted(() => {
  updateProductUrl();
  if (widgetId.value && numericProductId.value) initYotpoWidgets();
});

watch([widgetId, numericProductId], ([id, pid]) => {
  if (id && pid) {
    updateProductUrl();
    initYotpoWidgets();
  }
});
</script>
